import {CreateMsgType} from '../../../shared/link/link-usage-response';

export function upgradeOverlayMsgForBtn(
    resource: string,
    createMsgType: CreateMsgType
): string {
    resource = resource.replace('_', ' ');
    if (createMsgType === 'overQuota') {
        return `You've reached the maximum number of ${resource} allowed for your current plan.`;
    } else if (createMsgType === 'alias') {
        return 'Your current plan doesn\'t allow setting custom link ID.';
    } else if (createMsgType === 'expiration') {
        return 'Your current plan doesn\'t allow setting link expiration.';
    } else if (createMsgType === 'password') {
        return 'Your current plan doesn\'t allow setting a password for links.';
    } else if (createMsgType === 'utm') {
        return 'Your current plan doesn\'t include utm builder functionality.';
    } else if (createMsgType === 'retargeting') {
        return 'Your current plan doesn\'t include retargeting functionality.';
    } else {
        return `Your current plan doesn't allow creating ${resource}.`;
    }
}
